import { debounce as _debounce } from 'lodash';

import { listPrescriptionFills } from './index';

export default _debounce(listPrescriptionFills, 350);
